import './Footer.css';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as RefreshIcon } from 'assets/icons/refresh_icon_24.svg';
import en_pdf from '../../assets/pdfs/contact_webform_training_en.pdf';
import fr_pdf from '../../assets/pdfs/contact_webform_training_fr.pdf';
import User from 'utils/user.util';

export default function Footer({ selectedProperty }) {
    const { t, i18n } = useTranslation();
    const user = User.getUser();
    const navigate = useNavigate();

    return (
        <div className="footer">
            <div className="support-message">
                <p>
                    <a href={i18n.resolvedLanguage === 'en' ? en_pdf : fr_pdf} target="_blank">
                        {t('faq')}
                    </a>
                </p>
                <p>
                    Support:&nbsp;
                    <a
                        href={`mailto:cartecadeau@jll.com?subject=Support Retail Connection Portal: ${
                            user ? user.name : ''
                        }`}
                    >
                        cartecadeau@jll.com
                    </a>
                </p>
            </div>
            {selectedProperty && (
                <div
                    className="selected-property"
                    onClick={() =>
                        navigate('/selectproperty', { state: { from: window.location.pathname } })
                    }
                >
                    {selectedProperty.name}
                    <RefreshIcon className="refresh-icon" />
                </div>
            )}
        </div>
    );
}
